import { c as r } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
const n = {
  wrapper: ({ theme: a }) => /* @__PURE__ */ o([
    "display:flex;",
    ";position:sticky;max-width:100%;"
  ], r({
    backgroundColor: a.componentColors.fullPageCookieBanner.background
  })),
  textVariant: "dark",
  rejectButtonVariant: "secondary",
  manageButtonVariant: "textLink",
  zIndex: 9900,
  roundedModalContentWrapper: ({ theme: a }) => /* @__PURE__ */ o([
    "border-radius:",
    ";margin:0 ",
    ";width:61rem;",
    "{position:fixed;bottom:",
    ";width:calc(100% - 2 * ",
    ");}"
  ], a.space.xs, a.space.sm, a.breakpoints.mq.mobileMax, a.space.sm, a.space.sm),
  FullPageModalWrapper: () => /* @__PURE__ */ o([
    "background-color:rgba(0,0,0,0.1);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);"
  ])
};
export {
  n as default
};
